import React from "react";
import FieldCRMContact_PopoverMore from "./components/popover-menu/popover-more";
import FieldMultiselectDynamic from "../../../../fields3/generic/multiselect-dynamic/multiselect-dynamic";
import FieldConfig from "../../../../fields3/proto/field-config";
import FieldCRMContacts_Pill from "./components/pill";
import {ConditionType_ArrayIntersection} from "../../../../model2/conditions/condition-types";
import ItemModel from "../../../../model2/item/item-model";
import {LifecycleAction} from "../../../../gd/const/lifecycle";
import TableManager from "../../../../gd-modules/table/manager/table-manager";
import TaskListManager from "../../../../gd-modules/task-list/manager/manager";
import FieldCrmContacts_TableCell from "./render/table-cell";

export default class FieldCrmContacts extends FieldMultiselectDynamic {

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel = "Crm Contact";

        // if true will add no value option to options list (by default true for custom fields)
        this.noValueOption      = _.get(config,'addNoValueOption',true);

        // Label for no value option
        this.noValueOptionLabel = _.get(config,'noValueOptionLabel','No contact');

        // default placeholder for FORM element
        this.placeholder        = _.get(config,'placeholder','Please select');

        this.icon = 'i5-crm-contact';

        this.isSearchable = true;

        this.pillMaxWidth   = 120

        this.conditionTypes         = [ConditionType_ArrayIntersection]


        this.components.PopoverMenuMore     = FieldCRMContact_PopoverMore
        this.components.Pill                = FieldCRMContacts_Pill
        this.components.ValueIcon           = <span className={Classes("ui5-ico-16 m-r-10 fl-no-shrink", this.icon)}/>


        this.renderComponents.tableCell     = FieldCrmContacts_TableCell

        this.fieldParams.tableCellOnValueChange = this.tableCellOnValueChange

    }

    tableCellOnValueChange = async (item:ItemModel, value: number | null, manager:TableManager|TaskListManager) => {
// console.log("save", this.fieldId, " value=", value)


        // @ts-ignore
        item.task[this.fieldId] = value ? value : null
        // item.task.crmContactIds = value ? value : null

// console.log("udpated = ", item.task.crmContactIds)

        item.task.save()

        item._updateLastUpdateTime() // otherwise it wont re-render

        manager.update([LifecycleAction.PROCESS_DATA, LifecycleAction.RENDER])
    }



    getCsvValue(model:any) {
        const options : any = this._getOptions(model[this.fieldId])
        return _.isEmpty(options) ? '' : _.map(options, option=>option.label).join(', ');
    }

    getOptions() {

        if (!this._options) {

            if (gd.session._crmContacts) {
                this._options = gd.session._crmContacts.exportToOptions()
            } else {
                console.error("Try access session.crmContacts but not initialized #jd932")
                return []
            }

        }

        return this._options
    }


    // renderTable(model, onChange, cellWidth) {
    //     switch (this.access(model)) {
    //         case false      : return false;
    //         case 'read'     :
    //         case 'write'    :
    //             return <CrmContactsValueTable field={this} options={this._getOptions(model[this.fieldId])} width={cellWidth} />
    //     }
    // }
}
